import i18n from '@/i18n';

export const getCodeUpdateError = (errorCode: string): string => {
  switch (errorCode) {
    case 'CODE_NAME_REQUIRED':
      return i18n.global.t('createCodeCard.error.name');
    case 'CODE_NAME_EXISTS':
      return i18n.global.t('createCodeCard.error.unique');
    default:
      return null;
  }
};
